import { DatePicker } from "@mui/x-date-pickers";
import { isValid } from "date-fns";
import React from "react";
import { formatDate } from "../../utils/more/date_functions";

function DateInput({
  size,
  label,
  width,
  value = new Date(),
  sx,
  onChange = () => {},
  variant,
  className,
  disableHelperText,
  readOnly,
  disabled,
  required,
  autoFocus,
  hiddenLabel,
  helperText,
  maxDate,
  minDate,
  margin,
  disableOpenPicker,
  inputSx,
  endAdornment,
  placeholder,
}) {
  return (
    <DatePicker
      label={label}
      maxDate={maxDate}
      minDate={minDate}
      defaultValue={null}
      closeOnSelect
      value={value}
      disableOpenPicker={disableOpenPicker}
      autoFocus={autoFocus}
      disabled={disabled}
      readOnly={readOnly}
      onChange={(newValue) => onChange(newValue)}
      slotProps={{
        dialog: {
          transitionDuration: 100,
        },
        openPickerButton: {
          disableTouchRipple: true,
        },
        textField: {
          variant,
          autoFocus,
          hiddenLabel,
          sx: {
            width,
            ...sx,
          },
          label,
          size,
          placeholder,
          fullWidth: true,
          margin,
          helperText:
            helperText ||
            (!disableHelperText &&
              value &&
              isValid(new Date(value)) &&
              formatDate(new Date(value))),
          slotProps: {
            input: {
              endAdornment,
            },
          },
        },
      }}
    />
  );
}

export default DateInput;
